import React, {Fragment, useEffect, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {FaPlus} from 'react-icons/fa';
import {makeStyles} from '@material-ui/core/styles';
import {
  Fab,
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Page} from 'store/reducers/Page/pageAction';
import CardContainer from '../../components/CardContainer';
import {getPlaceOfSale} from '../../helpers/api';
import Enum from '../../helpers/enum';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tablerow: {
    cursor: 'pointer',
    transition: 'all ease 0.2s',
    '&:hover': {
      backgroundColor: '#CCC',
    },
  },
}));

export default function RegularTables1(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const {t} = useTranslation();
  const [place, setPlace] = useState([]);
  const [filterPlace, setfilterPlace] = useState([]);

  useEffect(() => {
    dispatch(Page(t('word.placesofsale')));
    const getAll = async () => {
      const res = await getPlaceOfSale();
      if (res && !res.errors) {
        setfilterPlace(res);
        setPlace(res);
      } else if (res.errors) {
        // eslint-disable-next-line no-restricted-syntax
        for (const i of res.errors) {
          props.openAlert(
            t(`message.${i.code}`, {param: t(`word.${i.field}`)}),
            i.color,
          );
        }
      }
    };
    getAll();
    // eslint-disable-next-line
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    let result = [];
    result = place.filter(
      (row) => row.placeofsale.toLowerCase().search(value) !== -1,
    );
    setfilterPlace(result);
  };

  const classes = useStyles();

  return (
    <>
      <CardContainer>
        <div className={classes.root}>
          <div className="card-header">
            <FormControl className="w-100 m-2">
              <InputLabel htmlFor="input-with-icon-adornment">
                {t('word.search')}
              </InputLabel>
              <Input
                onChange={(event) => handleSearch(event)}
                style={{maxWidth: '500px'}}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
            <div className="card-header--actions">
              <Link to="/placeofsale/new">
                <Fab size="small" color="secondary">
                  <span className="btn-wrapper--icon">
                    <FaPlus icon={['fas', 'plus']} />
                  </span>
                </Fab>
              </Link>
            </div>
          </div>
          <TableContainer className="mb-4" component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t('word.placeofsale')}</TableCell>
                  {Enum.arrPms.includes(props.pms) && (
                    <TableCell align="right">
                      {t('word.idplaceofsalepms')}
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {filterPlace &&
                  filterPlace.map((i) => (
                    <TableRow
                      key={i.idplaceofsale}
                      className={classes.tablerow}
                      onClick={() =>
                        history.push(`placeofsale/edit/${i.idplaceofsale}`)
                      }>
                      <TableCell component="th" scope="row">
                        {i.placeofsale}
                      </TableCell>
                      {Enum.arrPms.includes(props.pms) && (
                        <TableCell align="right">
                          {i.idplaceofsalepms}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CardContainer>
    </>
  );
}
